import React from 'react'
import { useSelector } from 'react-redux'
import { Image } from '../../components'
import { ResetPasswordPanel } from '../../containers'
import {
  getGlobalSettingLoadingStatus,
  getPortalLogoUrl
} from '../../redux/slices/global'
import {
  LoginSingleGridContainer,
  LoginGridItem,
  LoginContainer,
  LoginImageContainer
} from '../LoginPage/StyledLoginItems'

const ResetPasswordPage = () => {
  const appLogo = useSelector(getPortalLogoUrl)
  const globalLoading = useSelector(getGlobalSettingLoadingStatus)

  return (
    <LoginSingleGridContainer>
      <LoginGridItem>
        <LoginContainer>
          <LoginImageContainer>
            <Image
              width='100%'
              height='100%'
              src={appLogo}
              alt='Login'
              objectFit='contain'
              loading={globalLoading}
            />
          </LoginImageContainer>
          <ResetPasswordPanel />
        </LoginContainer>
      </LoginGridItem>
    </LoginSingleGridContainer>
  )
}

export default ResetPasswordPage
